"use client";

import { createContext, useContext, type ReactNode } from "react";

const BlockAnchorsEnabledContext = createContext(true);

/**
 * Suppresses hardcoded scroll-anchor ids (e.g. #book-demo) in contexts that
 * render the same block more than once, like the Studio block catalog, where
 * repeated ids fail WCAG 4.1.1.
 */
export function BlockAnchorsDisabled({
  children,
}: Readonly<{ children: ReactNode }>) {
  return (
    <BlockAnchorsEnabledContext.Provider value={false}>
      {children}
    </BlockAnchorsEnabledContext.Provider>
  );
}

export function useBlockAnchorsEnabled(): boolean {
  return useContext(BlockAnchorsEnabledContext);
}

export function useBlockAnchorId(id: string): string | undefined {
  return useBlockAnchorsEnabled() ? id : undefined;
}
